import { createApp } from 'vue';
import App from '@components/App';
import heyui from 'heyui';
import initHeyui from '@js/config/heyui-config';
import router from '@js/config/router-config';
import store from '@js/vuex/store';
import initComponents from '@js/vue/components';
import initFilters from '@js/vue/filters';
import initDirectives from '@js/vue/directives';
import '@js/vue/filters';

require('./css/app.less');

const app = createApp(App);
app.use(heyui);
app.use(store);
app.use(router);
initComponents(app);
initFilters(app);
initDirectives(app);
initHeyui();
app.mount('#app');

export default {};
